// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2r-2";
export var placeholderIcon = "_2r-3";
export var thumbnailCanvas = "_2r-1";
export var thumbnailWrapper = "_2r-0";